// extracted by mini-css-extract-plugin
export default {"header":"Header_header__D4yQD","logo":"Header_logo__jPP-X","navigation":"Header_navigation__xXhBK","login":"Header_login__BTOJi"};